import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material'
import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

type SinglePhase = 0 | 1

export interface SinglePhaseToggleButtonGroupProps extends Omit<
  ToggleButtonGroupProps,
  'exclusive' | 'children' | 'value' | 'onChange'
> {
  value?: SinglePhase
  /**
   * Called with null when the selected option is deselected.
   */
  onChange: (singlePhase: SinglePhase | null) => void
}

export default function SinglePhaseToggleButtonGroup({
  value,
  onChange,
  color = 'primary',
  ...props
}: SinglePhaseToggleButtonGroupProps) {
  const { t } = useTranslation()

  function handleChange(_event: MouseEvent<HTMLElement>, newValue: SinglePhase | null) {
    onChange(newValue)
  }

  return (
    <ToggleButtonGroup
      exclusive
      value={value ?? null}
      color={color}
      onChange={handleChange}
      {...props}
    >
      <ToggleButton value={1}>{t('singlePhase')}</ToggleButton>
      <ToggleButton value={0}>{t('threePhase')}</ToggleButton>
    </ToggleButtonGroup>
  )
}
